import { useRef } from "react";
import { ChevronLeft, ChevronRight, AudioLines, Languages, GraduationCap, Piano, Blocks, Bot } from "lucide-react";
import { SERVICES } from "@/data/content";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { imgProps } from "@/lib/img";

const ICONS = { AudioLines, Languages, GraduationCap, Piano, Blocks, Bot };

export default function Services() {
  const track = useRef(null);
  const scroll = (dir) => track.current?.scrollBy({ left: dir * 320, behavior: "smooth" });

  return (
    <section className="relative py-16 sm:py-24 px-4" data-testid="services-section">
      <div className="max-w-6xl mx-auto">
        <Reveal className="flex items-end justify-between gap-6">
          <div>
            <Eyebrow number="09" text="Студії" />
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white" data-testid="services-title">
              ІНДИВІДУАЛЬНІ <span className="text-gold-gradient">ЗАНЯТТЯ</span>
            </h2>
          </div>
          <div className="hidden sm:flex gap-2 shrink-0">
            <button
              type="button"
              onClick={() => scroll(-1)}
              className="w-11 h-11 rounded-full glass flex items-center justify-center text-amber-200 hover:text-amber-300 hover:border-amber-300/50 transition-colors cursor-pointer"
              data-testid="services-carousel-prev-button"
              aria-label="Назад"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              type="button"
              onClick={() => scroll(1)}
              className="w-11 h-11 rounded-full glass flex items-center justify-center text-amber-200 hover:text-amber-300 hover:border-amber-300/50 transition-colors cursor-pointer"
              data-testid="services-carousel-next-button"
              aria-label="Вперед"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div
            ref={track}
            className="mt-12 flex items-start gap-5 overflow-x-auto magical-scrollbar snap-x snap-mandatory pb-4 -mx-4 px-4"
            data-testid="services-carousel"
          >
            {SERVICES.map((s, i) => {
              const Icon = ICONS[s.icon];
              return (
                <div
                  key={s.name}
                  className="group snap-start shrink-0 w-64 sm:w-72 rounded-3xl overflow-hidden border border-amber-400/15 bg-[#0a211a] hover:border-amber-300/45 hover:-translate-y-2 hover:shadow-[0_20px_50px_rgba(230,184,92,0.15)] transition-all duration-500"
                  data-testid={`service-card-${i}`}
                >
                  <div className="overflow-hidden">
                    <img
                      {...imgProps(s.img, "288px")}
                      alt={s.name}
                      className="w-full h-auto block transition-transform duration-700 group-hover:scale-110"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3">
                      <span className="w-9 h-9 rounded-xl bg-amber-300/15 border border-amber-300/30 flex items-center justify-center shrink-0">
                        <Icon className="w-4 h-4 text-amber-300" />
                      </span>
                      <span className="font-semibold text-white text-base leading-tight">{s.name}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
